var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53 3.055l.708.708a3.5 3.5 0 010 4.95l-.177.176a3.5 3.5 0 11-4.95-4.95l.707.707a2.5 2.5 0 103.536 3.536l.176-.177a2.5 2.5 0 000-3.535l-.707-.707.707-.708zm3.36 3.006l-.708-.707a2.5 2.5 0 00-3.535-3.536l-.177.177a2.5 2.5 0 000 3.535l.707.707-.707.708-.707-.708a3.5 3.5 0 010-4.95l.176-.176a3.5 3.5 0 114.95 4.95z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/_/shared/assets/svg/chain.svg";
export { SvgChain as ReactComponent };